<template>
  <!--  :style="txtStyle" @touchstart="_touchStart" @touchmove="_touchMove" @touchend="_touchEnd" ref="wrap"  -->
  <div class="goods-wrap" :style="txtStyle" @touchstart="_touchStart" @touchmove="_touchMove" @touchend="_touchEnd" ref="wrap">
    <mu-infinite-scroll :loading="load" loadingText="拼命加载中" class="load" v-if="load"></mu-infinite-scroll>
    <!-- banner广告轮播 -->
    <div ref="content" v-show="!load">

      <div class="banner">
        <swiper :options="swiperOption" ref="mySwiper">
          <!-- 这部分放你要渲染的那些内容 -->
          <swiper-slide v-for="(img,index) in skuImages" :key="index">
            <div class="img-box">
              <imgs :width="700" :imagePath="img && img.imagePath && img.imagePath.imagePath"></imgs>
            </div>
          </swiper-slide>
          <!-- 这是轮播的小圆点 -->
          <div class="swiper-pagination swiper-pagination-custom" slot="pagination"></div>
        </swiper>
      </div>
      <!-- 商品信息 -->
      <div class="goods-content">
        <div class="goods-box">
          <span class="goodsName">{{goodsSkuMsg && goodsSkuMsg.sku && goodsSkuMsg.sku.skuName || ""}}</span>
          <mu-raised-button label="DIY" class="diy-button" primary @click="gotoDIY" />
        </div>
        <div class="price-box">
          <span class="price floatL">
            优惠价
            <samp v-if="goodsSkuMsg && goodsSkuMsg.sku && goodsSkuMsg.sku.unitPrice > 0">¥</samp>
            <label>{{goodsSkuMsg && goodsSkuMsg.sku && (goodsSkuMsg.sku.goodsPrice > 0 ? goodsSkuMsg.sku.goodsPrice : goodsSkuMsg.sku.priceDesc)}}</label>
          </span>
          <span class="price old-price floatR" v-if="goodsSkuMsg && goodsSkuMsg.sku && goodsSkuMsg.sku.unitPrice > 0">
            原价 <dd>￥{{goodsSkuMsg && goodsSkuMsg.sku && goodsSkuMsg.sku.unitPrice || 0.00}}</dd>
          </span>
          <div class="clearfix"></div>
        </div>
        <div class="tips saleNum">
          <span class="floatL">销量：{{goodsSkuMsg && goodsSkuMsg.sku && goodsSkuMsg.sku.saleNum || 0}}件</span>
          <span class="floatR">库存：{{goodsSkuMsg && goodsSkuMsg.sku && goodsSkuMsg.sku.stockNum || 0}}件</span>
          <div class="clearfix"></div>
        </div>
        <p class="tips">{{goodsSkuMsg && goodsSkuMsg.sku && goodsSkuMsg.sku.skuDesc || ""}}</p>
      </div>
      <!-- 领券 -->
      <template v-if="goodsSkuMsg && goodsSkuMsg.sku && goodsSkuMsg.sku.coupons && goodsSkuMsg.sku.coupons.length>0">
        <div class="coupon-title">
          <span>
            <samp>领券优惠</samp>
          </span>
        </div>
        <div v-on:click="couponPopup=true" class="button coupon-box">
          <div class="box">
            <div class="item redpackage">
              <span>红包</span>
            </div>
            <label>领取红包</label>
          </div>
          <div class="box">
            <div class="item coupon">
              <span>优惠券</span>
            </div>
            <label>领取优惠券</label>
          </div>
        </div>
      </template>

      <!-- 已选商品 -->
      <div class="button" v-on:click="bottomPopup=true">
        <span><samp>已选</samp>{{goodsSkuMsg && goodsSkuMsg.sku && goodsSkuMsg.sku.skuFields || ""}}</span>
      </div>
      <!-- 门店map -->
      <div class="store-map">
        <div class="title">
          <samp>门店</samp>
          <div class="verticalM-box address">
            <span class="ellipsis" v-on:click="addressPopup=true;isAddress=true" v-model="addressMsgShow">
              {{addressMsgShow}}
            </span>
          </div>
        </div>
        <div class="map-box map" v-if="amap">
          <el-amap vid="amapDemo" :center="amap.center" :map-manager="amap.amapManager" :zoom="amap.zoom" :events="amap.events" class="amap-demo">
          </el-amap>
        </div>
      </div>
      <!-- 评价 -->
      <div class="button" v-on:click="gotoEvalute">
        <span><samp>评价</samp><label v-if="GoodsComm.favRate">好评率{{GoodsComm.favRate}}%</label></span>
        <span class="floatR show-evalute">查看全部评价</span>
      </div>
      <div class="evaluate-detail">
        <div class="evaluate-label">
          <span class="label" v-for="tag in GoodsComm.commentTags">{{tag.name}}<samp>{{tag.nums}}</samp></span>
        </div>
        <p class="none-conment" v-if="GoodsCommList.length <1 ">对不起，暂时没有找到结果</p>
        <div class="evaluate-item" v-for="item in GoodsCommList">
          <div class="user-info">
            <span class="head">
              <imgs :imagePath="item.header && item.header.imagePath"></imgs>
            </span>
            <div class="content">
              <p class="name">{{item.memName}}</p>
              <p class="time">
                <span class="floatL">{{item.commTime}}</span>
                <div class="floatR">
                  <span class="star" v-for="i in 5" :class="{active:i <= Math.floor(item.starScore)}"></span>
                </div>
                <div class="clearfix"></div>
              </p>
            </div>
          </div>
          <div class="evaluate-content">{{item.commDesc}}</div>
          <div class="merchant-reply" v-if="item.replyDesc">
            <div class="header">
              <span class="floatL">美心商城回复:</span>
              <span class="floatR time">{{item.replyTime}}</span>
              <div class="clearfix"></div>
            </div>
            <div class="evaluate-content">{{item.replyDesc}}</div>
          </div>
        </div>
      </div>
      <div class="tripartite-box" :style="txtStyle">
        <span class="wxauth-title">
          {{tip}}
        </span>
      </div>
    </div>

    <!-- 商品选择 -->
    <mu-popup position="bottom" popupClass="custom-popup-bottom flex-column" :open="bottomPopup" @close="bottomPopup=false">
      <div class="flex-item">
        <div class="goods-detail">
          <div class="close-button" @click="bottomPopup=false"></div>
          <div class="goods-img">
            <imgs :width="200" :imagePath="skuImages && skuImages[0] && skuImages[0].imagePath && skuImages[0].imagePath.imagePath"></imgs>
          </div>
          <div class="goods-desc">
            <p class="price"><samp>¥</samp>{{goodsSkuMsg && goodsSkuMsg.sku && goodsSkuMsg.sku.goodsPrice || 0.00}}</p>
            <p class="desc overflowT2">{{goodsSkuMsg && goodsSkuMsg.sku && goodsSkuMsg.sku.skuName || ""}}</p>
          </div>
        </div>
        <div class="goods-label" v-for="item in (goodsSkuMsg && goodsSkuMsg.fields)">
          <p class="title">{{item.fieldName}}</p>
          <div class="label-list">
            <span class="label" v-for="value in item.values" @click="selectSku(item.fieldId,value.valueId)" :class="{active:value.isChecked==1}">{{value.valueName}}</span>
          </div>
        </div>
        <div class="goods-number">
          <p class="title">数量</p>
          <span class="add-btn" @click="changegoodsNum('reduce')"></span>
          <input v-model="goodsNum" />
          <span class="reduce-btn" @click="changegoodsNum('add')"></span>
          <samp>件</samp>
        </div>
      </div>
      <div class="bottom-button">
        <mu-raised-button label="确定" class="fullButton" primary @click="bottomPopup=false" />
      </div>
      <!-- <div class="bottom-button">
				<mu-raised-button label="加入购物车" class="add-cart" primary @click="addCart"/>
            	<mu-raised-button label="立即购买" class="buyNow" primary @click="buyNow"/>
			</div> -->
    </mu-popup>
    <!-- 领取优惠券 -->
    <mu-popup position="bottom" popupClass="coupon-receive-popup-bottom flex-column" :open="couponPopup" @close="couponPopup=false">
      <div class="flex-item">
        <div class="goods-detail">
          <div class="close-button" @click="couponPopup=false"></div>
          <div class="coupon-box">
            <div class="coupon-list">
              <div class="coupon-list-item title">
                领券
              </div>
              <emptyCart emptytext="当前店铺没有优惠券了~" v-show="goodsSkuMsg && goodsSkuMsg.sku && goodsSkuMsg.sku.coupons && goodsSkuMsg.sku.coupons.length<=0"></emptyCart>
              <table class="coupon-list-item">
                <tr v-for="couponItem in goodsSkuMsg && goodsSkuMsg.sku && goodsSkuMsg.sku.coupons && goodsSkuMsg.sku.coupons">
                  <td>
                    <!-- <div class="redpackage">￥{{couponItem.couponAmount}}</div> -->
                    <div :class="{coupon:couponItem.couponType==1,redpackage:couponItem.couponType==2}" v-if="couponItem.couponCate != 3">￥{{couponItem.couponAmount}}</div>
                    <div :class="{coupon:couponItem.couponType==1,redpackage:couponItem.couponType==2}" v-if="couponItem.couponCate == 3">{{couponItem.couponDiscount  | discount}}<samp>折</samp></div>
                  </td>
                  <td>
                    <p v-if="couponItem.couponType==1">{{couponItem.useAmount == 0 ? '不限制' : '满'+couponItem.useAmount+'可用'}}</p>
                    <!-- <p v-if="couponItem.couponType==2">{{couponItem.sendNum - couponItem.recivedNum == 0 ? '红包被领完啦' : '剩余'+couponItem.sendNum - couponItem.recivedNum +'个红包'}}</p> -->
                    <p v-if="couponItem.couponType==2">剩余{{(parseInt(couponItem.sendNum)-parseInt(couponItem.recivedNum))}}个红包</p>
                    <label>{{couponItem.effectiveTime}} - {{couponItem.overdueTime}}</label>
                  </td>
                  <td>
                    <button type="default" class="gray finish" disabled v-if="couponItem.isGet == 1">已领取</button>
                    <button type="default" class="gray" v-if="couponItem.isGet == 0" @click="getCoupon(couponItem.couponId,couponItem.couponType,couponItem.isGet)">领取</button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-button">
        <mu-raised-button label="确定" class="fullButton" primary @click="couponPopup=false" />
      </div>
    </mu-popup>

    <!-- 选择地区 -->
    <mu-popup position="bottom" popupClass="popup-bottom physical-popup" :open="addressPopup" @close="addressPopup= false">
      <h3>{{isAddress ? '所在地区' : '选择品牌'}}<span @click="addressPopup=false"></span></h3>
      <div class="popup-content">
        <!-- 地址选择 -->
        <div class="chooseList forbid-sel-text" v-if="isAddress" :class="{'chooseTwo':shoWOr==2,'chooseOne':shoWOr==1}">
          <div class="pShow">
            <samp class="sampOne" @click="clickProvince(1)" v-if="shoWOr<=1">请选择</samp>
            <samp @click="clickProvince(2)" v-if="shoWOr>=2">{{addressProvince}}</samp>
            <samp @click="clickProvince(2)" v-if="shoWOr>=3">{{cityNameShow}}</samp>
            <samp class="sampTwo" v-if="shoWOr==2">请选择</samp>
            <!-- <samp @click="clickProvince(2)" v-if="shoWOr<=3">{{cityNameShow}}</samp> -->
            <!-- <samp @click="clickProvince(3)" v-if="shoWOr==3">{{addressProvince}}</samp> -->
          </div>
          <!-- 省 -->
          <div class="chooseProvince" v-if="shoWOr==1">
            <span v-for="provinceShow in arealistMsg" @click="shooseProvince(provinceShow.areaId,provinceShow.areaName)">{{provinceShow.areaName}}</span>
          </div>
          <!-- 市 -->
          <div class="chooseProvince" v-if="shoWOr==2">
            <span v-for="cityShow in cityListShow" @click="shooseCity(cityShow.areaId,cityShow.areaName)" :class="{'chooseCityStyle':chooseCityId==cityShow.areaId}"> {{cityShow.areaName}}</span>
          </div>
          <!-- 区域 -->
          <div class="chooseProvince" v-if="shoWOr==3">
            <span v-for="areaListShow in areaAddressMsg" @click="shooseArea(areaListShow.areaId,areaListShow.areaName)" :class="{'chooseCityStyle':chooseAreaId==areaListShow.areaId}"> {{areaListShow.areaName}}</span>
          </div>
          <!-- 街道/镇 -->
          <div class="chooseProvince" v-if="shoWOr==4">
            <span v-for="streetListShow in getStreetMsgList" @click="shooseStreet(streetListShow.areaId,streetListShow.areaName)" :class="{'chooseCityStyle':chooseStreetId==streetListShow.areaId}"> {{streetListShow.areaName}}</span>
          </div>
        </div>
      </div>
      <div class="bottom-btn-box">
        <div class="bottom-full-button">
          <mu-raised-button label="确认" fullWidth primary @click="adressFirm" />
        </div>
      </div>
    </mu-popup>
    <mu-toast v-if="toast.isShow" :message="toast.messageTip" class="custom-toast" />
  </div>
</template>
<script type="text/javascript">
	import imgs from '@components/image/image';
	import emptyCart from '@components/empty/empty';
	import {mapActions,mapGetters} from 'vuex';
	import { storage } from "@common/utils/util.js";
	import { AMapManager } from 'vue-amap';
	export default{
		data(){
			return {
				tip:'继续拖动，查看详情',
				startY: 0,       //触摸位置
                moveY: 0,       //滑动时的位置
                disY: 0,       //移动距离
                txtStyle: '',
                height:0,
                startScrollH:0,//开始滑动  记录当前滚动的位置

      currentAddress: {
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        areaId: '',
        area: '',
        townId: '',
        town: '',
        address: '',
        postCode: '',
        consignee: '',
        mobile: '',
        isDefault: 0
      }, //当前地址信息
      addressMsgShow: '请选择地区', //页面展示的值
      addressProvince: '', //展示省份
      addressCity: '', //展示城市
      chooseCityId: '', //选中城市id
      chooseAreaId: '', //选中的区域id
      chooseStreetId: '', //获取的街道id
      arealistMsg: [], //当前获取到的省份信息
      cityListShow: [], //获取到的城市信息
      areaAddressMsg: [], //获取到城镇信息
      chooseBox: true, //选择地址弹框
      shoWOr: 1, //初始展示省份一级
      errorShow: 0, //错误信息提示
      toast2: false, //手机号码验证
      messageShow: '', //提示信息
      cityNameShow: '', //城市展示
      areaNameShow: '', //区域名
      getStreetMsgList: '', //最后街道信息
      streetNameShow: '', //街道信息
      addressCode: 0,
      addressPopup: false,
      isAddress: false, //是否是选择地区


				load:true,
				bottomPopup: false,
				swiperOption: {
	                //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	                /*notNextTick: true,  */
	                pagination: '.swiper-pagination',
	                autoplay : 5000,
	                paginationType : 'fraction',
					autoplayDisableOnInteraction : false,
                },
                goodsNum: 1,
                goodsSkuMsg: "",//商品sku信息
                goodsDetail: [],//商品详情
                skuImages: [],//商品套图
                imgIndex: 0,//商品展示图和高清图
                settleDatas:[],//结算店铺列表
		        OrderSettleMsg:{},//订单信息
		        couponAmounts:[],//选中的优惠券

		        GoodsComm:{},
				GoodsCommList:{},
				/*以下为地图板块*/
      			amap:null,
      			lat: null,
      			lng: null,

      			//以下为优惠券
      			couponPopup:false,//优惠券弹框
      			couponsList:[],//优惠券列表

      			toast:{
			          isShow:false,
			          messageTip:'',
			    },

			}
		},
		computed:{
		    ...mapGetters({
		       goodData:'goodData',//产品信息
		       isSelSku:'isSelSku',//商品选择框
		       scrollHeight:'scrollHeight'
        }),
        brandId() {
          return '';
        },
        cateId() {
          return '';
        },
		},
		mounted() {

			let count=0;
			this.yzInterval = setInterval(() => {
	        	count++;
	        	if(this.load == false){
	        		clearInterval(this.yzInterval);
	        		let cHeight = this.$refs.wrap.clientHeight;//元素的高度
					let oHeight  = this.$refs.content.clientHeight;//内容的高度
					this.height = oHeight - cHeight;//可滑动的最大值
	        	}
	      	}, 1000);
		 },
		watch:{
			goodData(val){
				this.goodsSkuMsg = this.goodData.goodsSkuMsg;
                this.goodsNum = this.goodData.goodsNum;

            },
		},
		methods:{
            ...mapActions({
            	listAreaMsg: 'listAreaMsg', //获取地域列表
            	getGoodsDetail: 'getGoodsDetail', //获取商品详情
                getCartGoodsNum:'getCartGoodsNum',//获取购物车商品数量
                getGoodsSkuMsg:'getGoodsSkuMsg',//获取商品SKU信息
                getGoodsSku:'getGoodsSku',//通过选择属性 获取 商品单品信息
                addMemCart:'addMemCart',//加入购物车
                getOrderSettleMsg:'getOrderSettleMsg',//直接购买
                saveGoodsData:'saveGoodsData',//保存购买的商品信息
                saveSelectSku:'saveSelectSku',
                getGoodsCommMsg:'getGoodsCommMsg',
                pageGoodsCommMsg:'pageGoodsCommMsg',
                pageDealerStore: 'pageDealerStore', //分页获取实体门店信息
                getListStoreCoupons:'getListStoreCoupons',//获取优惠券列表
                receiveCoupon:'receiveCoupon',//领取优惠券
                savescrollHeight:'savescrollHeight',//存储页面滚动高度
            }),
            _touchStart: function(ev) {
                ev = ev || event;
                if(ev.touches.length == 1){
                    // 手指按下的时候记录按下的位置
                    this.startY = ev.touches[0].clientY;
                    //记录手指按下时滚动的高度
                    this.startScrollH = this.scrollHeight.scrollHeight ;
                }
            },
            _touchMove: function(ev) {
                ev = ev || event;
                if(ev.touches.length == 1) {
                    // 滑动过程中的实时位置
                    this.moveY = ev.touches[0].clientY
                    // 滑动过程中实时计算滑动距离
                    this.disY = this.startY - this.moveY;
                    //console.log('disY==>', this.disY,this.height, this.startScrollH)
                    //鼠标按下时的滑动距离大于可滑动的最大距离
                    if ( this.startScrollH/this.height >= 0.98) {
                    	if(this.disY > 100 ){
	                   		//滑动距离大于100
	                        // this.txtStyle = "transform:translateY(-" + this.disY + "px)";
	                        this.txtStyle = "margin-bottom:" + this.disY + "px";
	                        document.getElementById('dishesWrapper').scrollTop = this.scrollHeight.scrollHeight  + this.disY;
	                        this.tip = '释放切换到详情'
	                    }else if(this.disY > 0 && this.disY < 100){
                    		this.txtStyle = "margin-bottom:" + this.disY + "px";
                    		document.getElementById('dishesWrapper').scrollTop = this.scrollHeight.scrollHeight  + this.disY;
	                        this.tip = '上拉切换到详情'
	                        //this.tip = '继续拖动，查看详情'
	                    }
	                }else{
	                	this.tip = '继续拖动，查看详情'
	                }
	            }
            },
            _touchEnd: function(ev) {
                if (event.changedTouches.length == 1) {
                    // 手指移动结束后的水平位置
                    let endX = event.changedTouches[0].clientY;
                    // 触摸开始与结束,手指移动的距离
                    //this.disY = this.startY - endX;
                    //如果距离小于100，页面不跳转，否则跳转至对应页面
                    //console.log("=>",this.disY,this.height, this.startScrollH)
                     //滑动结束，判断当前的滑动距离大于或等于时 偏移
                    if (this.disY > 100 &&  this.startScrollH/this.height >= 0.98) {
                     	this.$router.push({path: '/main/goodsDetail/detail?goodsId='+ this.goodsId + '&storeId='+ (this.storeId || '')+'&skuId=' + this.skuId});
                     }else{
	                 	this.txtStyle = "margin-bottom:" + 0 + "px";
	                 	document.getElementById('dishesWrapper').scrollTop = this.scrollHeight.scrollHeight;
	                 	this.tip = '继续拖动，查看详情';
	                 }
                 }
            },

            showTipMessage(isShow,msg){
		        this.toast.isShow = isShow;
		        this.toast.messageTip =msg;
		        setTimeout(() => {
		          this.toast.isShow = false
		        }, 1500);
		    },
            //领取优惠券
		    getCoupon(couponId,couponType,isGet){
		        if(isGet == 1){
		          return;
		        }
		        this.receiveCoupon([couponId,couponType]).then(res => {
		          if(res.success){
		          	this.showTipMessage(true,res.message || '领取成功！');
		            this.getSkuMsg();
		          }else{
		            this.showTipMessage(true,'领取失败，请稍后重试！');
		          }
		        }).catch(error => {console.log(error)
		          this.showTipMessage(true,'领取失败');
		        })
		    },
            //获取地图内容
		    getAmapContent() {
		      let vm = this;
		      let amap = {
		        resizeEnable: true,
		        zoom: 15,
		        center: [121.59996, 31.197646],
		        markers: [],
		        events: {
		          init(map) {
		            AMapUI.loadUI(['misc/MarkerList', 'overlay/SimpleMarker', 'overlay/SimpleInfoWindow'], function(MarkerList, SimpleMarker, SimpleInfoWindow) {
		              var $ = MarkerList.utils.$;

		              /*var defaultIconStyle = 'red'; //默认的图标样式*/
		              vm.markerList = new MarkerList({
		                map: map,
		                //ListElement对应的父节点或者ID
		                //listContainer: "myList", //document.getElementById("myList"),
		                //选中后显示

		                //从数据中读取位置, 返回lngLat
		                getPosition: function(item) {
		                  return [item.longitude, item.latitude];
		                },
		                //数据ID，如果不提供，默认使用数组索引，即index
		                getDataId: function(item, index) {
		                  return item.id;
		                },
		                getCityCode: function(item) {
		                  return item.cityCode;
		                },
		                getInfoWindow: function(data, context, recycledInfoWindow) {
		                	console.log(data);
		                  var innerHTML = MarkerList.utils.template(
		                    '<div class="info-title"><%- data.storeName %></div>' +
		                    '<div class="info-content">' +
		                    '<% if(data.relaPhone ){ %>' +
		                    '        <p class="info-item phone"><%- data.relaPhone %></p>' +
		                    '<% } %>' +
		                    '<p class="info-item address"><%- data.address %></p>' +
		                    '</div>'+
		                    '<a class="info-goHere" href="http://apis.map.qq.com/tools/poimarker?type=0&marker=coord:'+data.latitude+','+data.longitude+';title:'+data.address+';addr:'+data.address+'&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp"></a>', {
		                      data: data
		                    });

		                  var infowindow = new AMap.InfoWindow({
		                    placeSearch: true,
		                    asOrigin: true,
		                    asDestination: true,
		                    content: innerHTML,
		                    offset: new AMap.Pixel(0, -30)
		                  });
		                  return infowindow;
		                },
		                //构造marker用的options对象, content和title支持模板，也可以是函数，返回marker实例，或者返回options对象
		                getMarker: function(data, context, recycledMarker) {
		                  var label = 1;
		                  label += context.index;
		                  if (recycledMarker) {
		                    recycledMarker.setIconLabel(label);
		                    return;
		                  }

		                  return new SimpleMarker({
		                    containerClassNames: 'my-marker',
		                    iconStyle: vm.defaultIconStyle,
		                    iconLabel: label
		                  });
		                },
		                //构造列表元素，与getMarker类似，可以是函数，返回一个dom元素，或者模板 html string
		                getListElement: function(data, context, recycledListElement) {
		                  var label = 1;
		                  label += context.index;
		                  //使用模板创建
		                  var innerHTML = MarkerList.utils.template(
		                    '<span class="poibox-label"><%- label %></span>' +
		                    '<div class="poi-info-left">' +
		                    '    <h3 class="poi-title">' +
		                    '        <%- data.storeName %>' +
		                    '    </h3>' +
		                    '    <div class="poi-info">' +
		                    '        <p class="poi-addr">地址：<%- data.address %></p>' +
		                    '<% if(data.relaPhone ){ %>' +
		                    '        <p class="poi-addr">电话：<%- data.relaPhone %></p>' +
		                    '<% } %>' +
		                    '    </div>' +
		                    '</div>' +
		                    '<div class="clear"></div>', {
		                      data: data,
		                      label: label
		                    });

		                  if (recycledListElement) {
		                    recycledListElement.innerHTML = innerHTML;
		                    return recycledListElement;
		                  }

		                  return '<li class="poibox">' +
		                    innerHTML +
		                    '</li>';
		                },
		                //列表节点上监听的事件
		                listElementEvents: ['click', 'mouseenter', 'mouseleave'],
		                //marker上监听的事件
		                markerEvents: ['click', 'mouseover', 'mouseout'],
		                //makeSelectedEvents:false,
		                selectedClassNames: 'selected',
		                autoSetFitView: true
		              });


					//加载地图，调用浏览器定位服务
				    var geolocation;
				    map.plugin('AMap.Geolocation', function() {
				        geolocation = new AMap.Geolocation({
				            enableHighAccuracy: true,//是否使用高精度定位，默认:true
				            timeout: 10000,          //超过10秒后停止定位，默认：无穷大
				            buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
				            zoomToAccuracy: true,      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
				            buttonPosition:'RB'
				        });
				        map.addControl(geolocation);
				        geolocation.getCurrentPosition();
				        AMap.event.addListener(geolocation, 'complete', onComplete);//返回定位信息
				        AMap.event.addListener(geolocation, 'error', onError);      //返回定位出错信息
				    });

				    //解析定位结果
				    function onComplete(data) {
				    	console.log("lng",data.position.getLng())
				    	let positionLists = [];
				    	let positionList = {
				    		longitude: data.position.getLng(),
				    		latitude: data.position.getLat()
				    	}

				    	vm.lng = data.position.getLng();
                		vm.lat = data.position.getLat();
	                    //地图显示当前城市
	                    let params = {
	                      mapType: 2,
	                      longitude: vm.currentAddress.provinceId ? "" : data.position.getLng(),
	                      latitude: vm.currentAddress.cityId ? "" : data.position.getLat(),
	                      provinceCode: '',
	                      cityCode: '',
	                      areaCode: '',
	                      brandId: '',
	                      storeId: vm.storeId || '',
	                      goodsId: vm.goodsId || '',
	                      provinceId: vm.currentAddress.provinceId || "",
	                      cityId: vm.currentAddress.cityId || "",
	                      areaId: vm.currentAddress.areaId || "",
	                    }
	                    vm.pageDealerStore([params, 1, 20]).then(res => {
	                      vm.markerList.render(res.result);
	                    })

				    	// positionLists.push(positionList);
				    	// vm.markerList.render(positionLists);
				    }
				    //解析定位错误信息
				    function onError(data) {
		              	//实例化城市查询类
			              var citysearch = new AMap.CitySearch();
			              // var city = "重庆"
			              //自动获取用户IP，返回当前城市
			              citysearch.getLocalCity(function(status, result) {
			                if (status === 'complete' && result.info === 'OK') {
			                  if (result && result.city && result.bounds) {
			                  	vm.lng = result.bounds.eb.lng;
	                    		vm.lat = result.bounds.eb.lat;
			                    //地图显示当前城市
			                    let params = {
			                      mapType: 2,
			                      longitude: vm.currentAddress.provinceId ? "" : result.bounds.eb.lng,
			                      latitude: vm.currentAddress.cityId ? "" : result.bounds.eb.lat,
			                      provinceCode: '',
			                      cityCode: '',
			                      areaCode: '',
			                      brandId: '',
			                      storeId: vm.storeId || '',
			                      goodsId: vm.goodsId || '',
			                      provinceId: vm.currentAddress.provinceId || "",
			                      cityId: vm.currentAddress.cityId || "",
			                      areaId: vm.currentAddress.areaId || "",
			                    }
			                    vm.pageDealerStore([params, 1, 20]).then(res => {
			                      vm.markerList.render(res.result);
			                    })
			                  }
			                }
			              });
				    	}
		            });
		          }
		        }
		      }
		      this.amap = amap;
		    },
		    //获取实体门店数据
		    getPageDealerStore(lat, lng) {
		      let params = {
		        mapType: 2,
		        longitude: this.lng || "",
		        latitude: this.lat || "",
		        provinceCode: '',
		        cityCode: '',
		        areaCode: '',
		        brandId: '',
		        storeId: this.storeId || '',
                goodsId: this.goodsId || '',
                provinceId: this.currentAddress.provinceId || "",
		        cityId: this.currentAddress.cityId || "",
		        areaId: this.currentAddress.areaId || "",
		      }
		      this.pageDealerStore([params, 1, 20]).then(res => {
		        this.markerList.render(res.result);
		      })
		    },
            //地址出现弹框
		    clickProvince(areaId) {
		      this.addressMsgShow = '请选择区域';
		      this.addressProvince = '';
		      this.cityNameShow = '';
		      this.currentAddress.province = '';
		      this.currentAddress.provinceId = '';
		      this.currentAddress.city = '';
		      this.currentAddress.cityId = '';
		      this.currentAddress.areaId = '';
		      this.currentAddress.area = '';
		      this.currentAddress.townId = '';
		      this.currentAddress.town = '';
		      this.shoWOr = 1;
		    },
		    // 点击省出现下级
    shooseProvince(provinceId, provinceName) {
      //this.clickProvince();
      this.shoWOr = 2;
      this.getCityListShow(provinceId); //获取城市列表
      this.currentAddress.provinceId = provinceId; //保存id
      this.currentAddress.province = provinceName; //保存名字
      this.addressProvince = provinceName; //名字在页面展示
      this.addressMsgShow = provinceName; //选择框展示
    },
    //点击城市出现下级
    shooseCity(cityId, cityName) {
      this.getTownMsg(cityId); //获取城镇信息
      //setTimeout(this.getTownMsg(cityId), 1); //获取城镇信息
      //this.addressMsgShow = this.addressProvince + cityName; //选择框展示城市名字
      this.currentAddress.city = cityName; //保存城市名字
      this.cityNameShow = cityName; //展示城市名字
      this.currentAddress.cityId = cityId; //保存城市id
      this.chooseCityId = cityId; //选中城市的id
      this.addressMsgShow = this.addressProvince  + '/' + this.cityNameShow;
      this.listAreaMsg(cityId).then(res => {
        this.areaAddressMsg = res.target;
        if (this.areaAddressMsg.length == 0) {
          this.addressMsgShow = this.addressProvince + '/' +this.cityNameShow; //选择框展示城市名字
          this.shoWOr = 2; //关闭地址选择框
          return;
        } else if (this.areaAddressMsg.length != 0) {
          this.shoWOr = 3;
        }
      })
    },
    //点击区域出现下一级
    shooseArea(areaId, areaName) {
      this.currentAddress.areaId = areaId; //保存的区域id
      this.chooseAreaId = areaId; //保存的id
      this.currentAddress.area = areaName; //保存地址名称
      this.areaNameShow = areaName; //展示的街道
      this.addressMsgShow = this.addressProvince  + '/' + this.cityNameShow  + '/' + this.areaNameShow;
      //this.chooseBox = false; //关闭地址框
      this.listAreaMsg(areaId).then(res => {
        this.getStreetMsgList = res.target;
        if (this.getStreetMsgList.length == 0) {
          this.shoWOr = 3;
        } else {
          this.shoWOr = 4;
        }
      })
    },
    //点击街道出现下一级
    shooseStreet(areaId, areaName) {
      this.currentAddress.townId = areaId; //保存的区域id
      this.chooseStreetId = areaId; //保存街道id
      this.currentAddress.town = areaName; //保存地址名称
      this.streetNameShow = areaName; //展示的街道
      //this.chooseBox = false; //关闭地址框
      this.addressMsgShow = this.addressProvince  + '/' + this.cityNameShow  + '/' + this.areaNameShow  + '/' + this.streetNameShow;
      this.listAreaMsg(areaId).then(res => {
        this.lastMsg = res.target;
      })

    },
    //获取区域的列表api
    getAreaMsg(areaId) {
      this.listAreaMsg(areaId).then(res => {
        this.getStreetMsgList = res.target;
      })
    },
    //获取城镇信息api
    getTownMsg(cityId) {
      this.listAreaMsg(cityId).then(res => {
        this.areaAddressMsg = res.target;
      })
    },
    //获取城市的列表api
    getCityListShow(provinceId) {
      this.listAreaMsg(provinceId).then(result => {
        this.cityListShow = result.target;
      })
    },
    //获取省份列表api
    getListAreaMsg(addressCode) {
      this.listAreaMsg(addressCode).then(result => {
        this.arealistMsg = result.target;

      }).catch(error => {})
    },
		    //地址看确认
		    adressFirm(){
				this.addressPopup= false;
				//this.getAmapContent();
				this.getPageDealerStore();
			},
             //11.7.获取商品评价总览
            getGoodsComm(){
               this.getGoodsCommMsg([this.goodsId]).then(res=>{
					this.GoodsComm = res;
				})
            },
             //11.8.分页查询商品评价
            getGoodsCommContent(){
               this.pageGoodsCommMsg([this.goodsId,1,3]).then(res=>{
					this.GoodsCommList = res.result;
				})
            },
            //18.2.获取商品SKU信息
            getSkuMsg(){


                if(this.goodsSkuMsg){
                    this.goodsSkuMsg.fields.forEach(field => {
                        field.values.forEach((item,index) => {
                          if(item.isChecked ==1 && item.isImage == 1){
                            this.skuImages = item.showImages;
                            this.imgIndex = index;
                          }
                        })
                    })
                    this.load = false;
                }else{
                    this.getGoodsSkuMsg([this.goodsId,this.skuId]).then(res=>{
                        this.goodsSkuMsg = res;
                        this.goodsSkuMsg.fields.forEach(field => {
                            field.values.forEach((item,index) => {
                              if(item.isChecked ==1 && item.isImage == 1){
                                this.skuImages = item.showImages;
                                this.imgIndex = index;
                              }
                            })
                        })
                        this.saveGoodForBuy();//将需要购买的商品信息存储
                        this.load = false;
                    })
                }

            },
            //保存要购买的商品的信息
            saveGoodForBuy(){
            	let _this = this;
            	this.saveGoodsData({
                  	goodsSkuMsg:  _this.goodsSkuMsg,
                  	goodsNum: _this.goodsNum,
                  	//skuImages: _this.skuImages,
                });
            },
            //选择商品属性
		    selectSku(fieldId,valueId){
		    	this.saveSelectSku({
		    		fieldId:fieldId,
		    		valueId:valueId,
		    	})
		     	//获取商品单品信息
		        let values = [];
		        this.goodData.goodsSkuMsg.fields.forEach(field => {
		            field.values.forEach(item => {
		              if(item.isChecked == 1){
		              	if(item.isImage == 1){
	                       this.skuImages = item.showImages;
	                    }
		                let value = {
		                  fieldId: item.fieldId,
		                  valueId: item.valueId
		                }
		                values.push(value);
		              }
		            })
		        });
			    this.getGoodsSku([this.goodsId,values]).then(res => {

			    });

		    },
            //商品加减
	 		changegoodsNum(action){
	 			if (action == 'add') {
	 				this.goodsNum += 1;	 			}
	 			else if (action == 'reduce') {
	 				if(this.goodsNum==1)
	 					return;
	 				this.goodsNum -= 1;
	 			}
	 			this.saveGoodForBuy();//将需要购买的商品信息存储
	 		},
		    gotoEvalute(){
		    	this.$router.push({path: '/main/goodsDetail/evaluate?goodsId='+ this.goodsId + '&storeId='+ this.storeId+'&skuId=' + this.skuId});
		    },
		    gotoDIY(){
		    	this.$router.push({
		    		path: `/main/diyPage?brandId=${this.goodsSkuMsg.brandId}&cateId=${this.goodsSkuMsg.cateId}`
		    	})
		    },

		},
		components:{
			imgs,
			 emptyCart,
		},
		created(){
      this.load = true;
      this.goodsId = this.$route.query.goodsId || this.$route.query.linkTarget;
      this.skuId = this.$route.query.skuId || 0;
      this.storeId = this.$route.query.storeId;
			this.getAmapContent();
			this.getGoodsComm();
			this.getGoodsCommContent();
            this.getSkuMsg();
            //获取地域列表
    		this.getListAreaMsg(this.addressCode);

		}
	}
</script>
<style lang="scss" rel="stylesheet/scss">
@import "src/common/sass/mixin.scss";
.goods-wrap {
  height: 100%;
  .swiper-container {
    height: 100%;
  }
  .tripartite-box {
    text-align: center;
    padding: 0.5rem 0rem;
    .wxauth-title {
      color: #999;
      @include font-dpr(14px);
      padding: 0 3rem;
      position: relative;
      &:before,
      &:after {
        content: "";
        display: inline-block;
        width: 2.5rem;
        height: 1px;
        position: absolute;
        top: 50%;
        background: #e5e5e5;
      }
      &:before {
        left: 0;
      }
      &:after {
        right: 0;
      }
    }
  }
  .banner {
    /*height: 8.0rem;*/
    overflow: hidden;
    .swiper-pagination-custom {
      width: 1.325rem;
      height: 0.55rem;
      right: 0.45rem;
      left: auto;
      opacity: 0.67;
      background: #ffffff;
      box-shadow: 0 0.05rem 0.1rem 0 rgba(0, 0, 0, 0.5);
      border-radius: 2.5rem;
      @include font-dpr(16px);
      color: #999999;
      > span {
        color: #444444;
        &.swiper-pagination-total {
          color: #999999;
        }
      }
    }
  }
  .goods-content {
    margin-bottom: 0.2rem;
    padding: 0.3rem 0.35rem;
    background: #fff;
    .goods-box {
      min-height: 1rem;
      position: relative;
      .goodsName {
        display: inline-block;
        @include font-dpr(16px);
        color: #444444;
        margin-right: 2.125rem;
        text-align: justify;
      }
      .diy-button {
        width: 1.4rem;
        height: 1rem;
        min-width: auto;
        position: absolute;
        right: 0;
        top: 0;
        background: #ff9900 !important;
        border-radius: 0;
        box-shadow: none;
        .mu-raised-button-label {
          @include font-dpr(20px);
        }
      }
    }
    .price-box {
      font-size: 0;
      padding: 0.25rem 0;
      .price {
        /*display: inline-block;
					width: 50%;*/
        @include font-dpr(14px);
        color: #666666;
        > samp {
          @include font-dpr(13px);
          color: #e60012;
        }
        > label {
          @include font-dpr(20px);
          color: #e60012;
        }
        &.old-price {
          > dd {
            display: inline-block;
            position: relative;
            @include line(-2px, -2px, #666666, 1px);
          }
        }
      }
    }
    > p.tips {
      @include font-dpr(14px);
      color: #999999;
    }
    > div.saleNum {
      padding-bottom: 0.3rem;
      color: #999999;
      @include font-dpr(14px);
    }
  }
  .button {
    margin-top: 0.2rem;
    color: #e60012;
    padding: 0.45rem 0.75rem 0.45rem 0.35rem;
    background: #fff;
    position: relative;
    @include arrow(#999999, right, 0.2rem, 1px, 0.35rem);
    > span {
      display: inline-block;
      text-align: justify;
      > samp {
        color: #999999;
        padding-right: 0.375rem;
      }
    }
    .show-evalute {
      color: #999999;
    }
  }
  .coupon-title {
    margin-top: 0.2rem;
    color: #999;
    padding: 0.35rem 0.75rem 0.35rem 0.35rem;
    background: #fff;
    position: relative;
  }
  .button.coupon-box {
    margin-top: 0.02rem;
    padding: 0.15rem 0.75rem 0.35rem 0.35rem;
    div.box {
      padding-top: 0.2rem;
      color: #333;
      clear: both;
      .redpackage {
        background: url(/static/images/get_red_packet_details@3x.png) no-repeat;
        background-size: 100% 100%;
      }
      .coupon {
        background: url(/static/images/get_coupon_details@3x.png) no-repeat;
        background-size: 100% 100%;
      }
      .item {
        @include font-dpr(12px);
        color: #ff6868;
        width: auto;
        float: left;
        border-radius: 2px;
        span {
          line-height: 1.7;
          display: inline-block;
          padding: 0rem 0.2rem;
          /*padding-left: 0.2rem;*/
        }
        span:nth-child(2) {
          border-left: 1px dashed #ff6868;
          padding-right: 0.2rem;
        }
      }
      label {
        line-height: 1.7;
        margin-left: 0.1rem;
      }
    }
  }
  .store-map {
    margin-top: 0.2rem;
    color: #e60012;
    background: #fff;
    position: relative;
    > div.title {
      padding: 0.45rem 0rem 0.45rem 0.35rem;
      height: 1.3rem;
      > samp {
        color: #999999;
        padding-right: 0.375rem;
      }
    }
    .verticalM-box {
      @include font-dpr(12px);
      color: #222222;
      position: absolute;
      right: 0.35rem;
      top: 0.3rem;
      > span {
        display: inline-block;
        height: 0.75rem;
        padding: 0 0.35rem;
        line-height: 0.75rem;
        background: #f3f3f3;
        border: 1px solid #cfcfcf;
        border-radius: 2px;
        vertical-align: top;
        position: relative;
        &:after {
          @include triangle(down, 0.15rem, #999999);
          position: absolute;
          right: 0.35rem;
          top: 50%;
          margin-top: -0.075rem;
        }
      }
      &.address {
        width: 45%;
        > span {
          padding-right: 0.6rem;
        }
      }
      &.brand {
        width: 35%;
        > span {
          width: 100%;
        }
      }
    }
    .map-box.map {
      height: 6rem;
      .amap-info-combo .keyword {
        background-color: rgba(255, 255, 255, 0);
      }
      .amap-info-combo {
        color: #666;
      }
      .amap-marker {
        &.selected {
          .amap-simple-marker-icon {
            background: url(/static/images/physical_store_blue2.png) no-repeat
              center;
            background-size: 0.65rem 0.725rem;
          }
        }
      }
      .amap-info-content {
        width: 6rem;
      }
      .amap-demo {
        display: inline-block;
        width: 100%;
        height: 6rem;
        .amap-simple-marker-icon {
          width: 0.45rem;
          height: 0.625rem;
          background: url(/static/images/physical_store.png) no-repeat center;
          background-size: auto 100%;
        }
        .amap-simple-marker-style-red {
          width: 0.45rem;
          height: 0.625rem;
          color: #fff;
        }
        .amap-simple-marker-label {
          line-height: 0.55rem;
          color: #fff;
          @include font-dpr(12px);
        }
      }
      .info-title {
        padding: 0.25rem 0.1rem;
        color: #333333;
      }
      .info-goHere {
        display: inline-block;
        width: 1.25rem;
        height: 1.25rem;
        background: url(/static/images/map_here_3x.png) no-repeat center;
        background-size: 100%;
        position: absolute;
        right: 1rem;
        top: -0.5rem;
      }
      .info-item {
        padding: 0.1rem 0rem 0.2rem 0.5rem;
        @include font-dpr(12px);
        color: #989898;
        &.phone {
          background: url(/static/images/map_tel.png) no-repeat 0.1rem 0.2rem;
          background-size: 0.25rem auto;
        }
        &.address {
          background: url(/static/images/map_address.png) no-repeat 0.1rem
            0.2rem;
          background-size: 0.3rem auto;
        }
      }
    }
  }
  .evaluate-detail {
    margin-top: 1px;
    padding: 0.25rem 0.2rem;
    background: #fff;
    .evaluate-label {
      > .label {
        display: inline-block;
        padding: 0.175rem;
        margin: 0 0.2rem 0.3rem 0.2rem;
        background: #f3f3f3;
        border-radius: 0.5rem;
        @include font-dpr(12px);
        color: #434343;
        > samp {
          padding-left: 0.2rem;
          color: #a6a6a6;
        }
      }
    }
    .none-conment {
      text-align: center;
      color: #666;
    }
    .evaluate-item {
      border-bottom: 2px solid #e5e5e5;
      margin: 0.35rem 0 0.5rem 0;
      &:last-child {
        border-bottom: 0;
      }
      .user-info {
        position: relative;
        margin-bottom: 0.3rem;
        .head {
          display: inline-block;
          width: 0.8rem;
          height: 0.8rem;
          border-radius: 50%;
          overflow: hidden;
        }
        .content {
          position: absolute;
          left: 1rem;
          right: 0;
          top: 0;
          > p {
            @include font-dpr(12px);
            color: #434343;
            &.time {
              color: #b2b2b2;
            }
          }
          .star {
            display: inline-block;
            width: 0.3rem;
            height: 0.3rem;
            margin-left: 0.125rem;
            background: url(/static/images/star_gray_3x.png) no-repeat center;
            background-size: cover;
            &.active {
              background: url(/static/images/star_red_3x.png) no-repeat center;
              background-size: cover;
            }
          }
        }
      }
      .evaluate-content {
        color: #333333;
        line-height: 1.5;
        margin-bottom: 0.25rem;
        text-align: justify;
      }
      .merchant-reply {
        padding: 0.25rem;
        padding-bottom: 1px;
        background: #f0f0f0;
        border-radius: 0.125rem;
        margin-bottom: 0.375rem;
        .header {
          margin-bottom: 0.25rem;
          > span {
            color: #e60012;
            &.time {
              color: #b2b2b2;
            }
          }
        }
      }
    }
  }
}
//底部全屏 button
.bottom-btn-box {
  .bottom-full-button {
    .mu-raised-button-full {
      @include font-dpr(16px);
      line-height: 1.25rem;
      height: 1.25rem;
      background-image: linear-gradient(-90deg, #ff4901 0%, #ff7701 100%);
    }
  }
}
.physical-popup {
  height: auto;
  .popup-content {
    max-height: 6.5rem;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    .chooseList {
      //地址选择
      width: 100%;
      height: 9.5rem;
      overflow: auto;
      > .pShow {
        display: inline-block;
        position: fixed;
        background: #fff;
        width: 100%;
        samp {
          @include font-dpr(14px);
          cursor: pointer;
          line-height: 45px;
          margin: 0px 16px;
        }
      }
      .chooseProvince {
        margin-top: 46px;
        margin-bottom: 95px;
        width: 100%;
        @include font-dpr(14px);
        padding-top: 10px;
        border-top: 1px solid #eaeaea;
        span {
          display: block;
          @include font-dpr(14px);
          cursor: pointer;
          margin: 9px 0px;
          width: 100%;
          text-align: left;
          text-indent: 14px;
          &.chooseCityStyle {
            color: #e60012;
          }
        }
      }
      &.chooseOne {
        .pShow > samp.sampOne {
          @include font-dpr(14px);
          color: #e60012;
          display: inline-block;
          border-bottom: 1px solid #e60012;
        }
      }
      &.chooseTwo {
        .pShow > samp.sampTwo {
          @include font-dpr(14px);
          color: #e60012;
          display: inline-block;
          border-bottom: 1px solid #e60012;
        }
      }
    }
    .mu-checkbox {
      display: block;
      height: auto;
      line-height: inherit;
      padding: 0.4rem 0.35rem;
      @include bdT(#e5e5e5, top);
      &:first-child {
        &:after {
          display: none;
        }
      }
      .mu-checkbox-wrapper {
        .mu-checkbox-ripple-wrapper {
          width: 1.2rem;
          height: 1.2rem;
          top: 50%;
          right: 0.2rem;
          margin-top: -0.6rem;
          color: #e60012 !important;
        }
        .mu-checkbox-label {
          @include font-dpr(14px);
          color: #333333;
        }
        .mu-checkbox-icon {
          width: 0.45rem;
          height: 0.45rem;
          margin-right: 0.3rem;
          .mu-checkbox-svg-icon {
            height: 0.45rem;
            height: 0.45rem;
          }
          .mu-checkbox-icon-checked {
            color: #e60012;
          }
          .mu-checkbox-icon-uncheck {
            color: #dddddd;
          }
        }
      }
    }
  }
}
.coupon-receive-popup-bottom {
  width: 100%;
  height: 9.25rem;
  background: #fff;
  font-size: 0;
  .flex-item {
    padding: 0.2rem 0.35rem;
    .goods-detail {
      position: relative;
      padding-bottom: 0.2rem;
      .close-button {
        display: inline-block;
        width: 0.3rem;
        height: 0.3rem;
        position: absolute;
        top: 0;
        right: 0;
        background: url(/static/images/dialog_cancel_3x.png) no-repeat center;
        background-size: cover;
        z-index: 5;
      }
      .coupon-box {
        .coupon-list {
          .coupon-list-item.title {
            text-align: center;
            @include font-dpr(18px);
            color: #333333;
            @include bdT(rgba(255, 255, 255, 0), bottom);
            margin-bottom: 0rem;
          }
          .coupon-list-item {
            width: 100%;
            @include font-dpr(14px);
            color: #333333;
            padding: 0.35rem 0;
            margin-bottom: 0.2rem;
            tr {
              height: 1.6rem;

              border-bottom: 1px solid #efefef;
            }
            .redpackage {
              background: url(/static/images/red_packet_bg_3x.png) no-repeat
                center;
              height: 1.125rem;
              background-size: 80% 1rem;
              color: #fff;
              /*margin-right: 0.2rem;*/
              line-height: 1.2rem;
              text-align: center;
            }
            .coupon {
              background: url(/static/images/personal_coupon_3x.png) no-repeat
                center;
              height: 1.125rem;
              background-size: 80% 1rem;
              color: #fff;
              /*margin-right: 0.2rem;*/
              line-height: 1.2rem;
              text-align: center;
            }
            p {
              color: #666666;
              line-height: 1.5;
            }
            label {
              @include font-dpr(12px);
              color: #999;
              line-height: 1;
            }
            .gray {
              @include font-dpr(12px);
              float: right;
              background: #fff;
              border: 1px solid #a5a5a5;
              color: #333;
              width: 1.5rem;
              height: 1rem;
              max-height: 0.8rem;
              border-radius: 5px;
              .mu-raised-button-label {
                padding: 0;
              }
            }
            .gray.finish {
              border: 1px solid #e2e2e2;
              color: #dadada;
            }
          }
        }
      }
    }
  }
  .mu-raised-button {
    display: inline-block;
    width: 50%;
    border: 0px solid;
    box-shadow: none;
    border-radius: 0;
    vertical-align: top;
    min-width: auto;
    height: 1.25rem;
    color: #fff;
    @include font-dpr(16px);

    &.fullButton {
      width: 100%;
      background-image: linear-gradient(-90deg, #ff4901 0%, #ff7701 100%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// goods.vue?4043f463